import { Weather } from "../content-types/schemas/global.schema";
import { safeParseWithFallback } from "../utils/safe-parse-with-fallback";
import { strapiClient } from "./strapi-client";

export const getWeather = async () => {
  const response = await strapiClient.single("global").find({
    populate: {
      weather: true,
    },
  });

  // Извлекаем только weather компонент из ответа
  const weatherData = response.data?.weather;

  if (!weatherData) {
    return null;
  }

  // Валидируем данные компонента
  const parsed = safeParseWithFallback(Weather.base, weatherData, "getWeather");

  return parsed;
};
